module.exports = "/_next/static/images/FrameMobile-8b40d86aa157da74406bb08669b0019c.webp";